import axiosInstance from '@/utils/api.js'

function validation (payload) {
  payload.affector_type = parseInt(payload.affector_type, 10)
}

var state = {
  firewallRules: [],
  fwSubst: []
}

var getters = {
  FIREWALL_RULES: (state) => {
    return state.firewallRules
  },
  FW_SUBST: (state) => {
    return state.fwSubst
  }
}

var mutations = {
  SET_FIREWALL_RULES: (state, payload) => {
    state.firewallRules = payload
  },
  SET_FW_SUBST: (state, payload) => {
    state.fwSubst = payload
  }
}

var actions = {
  GET_FIREWALL_RULES: async (context, payload) => {
    let result = await axiosInstance.get('/settings/fw_rules')
    if (result.status === 200) {
      context.commit('SET_FIREWALL_RULES', result.data)
    }
  },
  CREATE_FIREWALL_RULES: (context, payload) => {
    validation(payload)
    return axiosInstance.post('/settings/fw_rules', payload)
  },
  UPDATE_FIREWALL_RULES: (context, payload) => {
    validation(payload)
    return axiosInstance.put('/settings/fw_rules', payload)
  },
  DELETE_FIREWALL_RULES: (context, payload) => {
    return axiosInstance.delete('/settings/fw_rules?rule_id=' + payload)
  },
  GET_FW_EVENT_MASKS: async (context, payload) => {
    let result = await axiosInstance.get('/settings/fw_subst')
    if (result.status === 200) {
      context.commit('SET_FW_SUBST', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/settings/firewallRules.js